export default "__VITE_ASSET__nYYl_aDE__"